import Button from '@/features/openTabs/components/AccountActionButton'
import { useOpenTabModalBack } from '@/features/openTabs/hooks/useOpenTabModalBack'
import Modal from '@/features/ui/components/Modal'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

interface CancelPaymentModalProps {
    onConfirm: () => void
    onKeep: () => void
}

const CancelPaymentModal: FC<CancelPaymentModalProps> = ({ onConfirm, onKeep }) => {
    const { t } = useTranslation('app')
    useOpenTabModalBack(onKeep)

    return (
        <Modal>
            <View style={styles.container} testID="open-account-payment-cancel-modal">
                <Typography.Heading variant="h3" style={styles.title}>
                    {t('openTabs.payment.cancelTitle')}
                </Typography.Heading>
                <View style={styles.actions}>
                    <Button color="secondary" onPress={onConfirm} style={styles.button}>
                        {t('openTabs.payment.cancelConfirm')}
                    </Button>
                    <Button color="secondary" type="outline" onPress={onKeep} style={styles.button}>
                        {t('openTabs.payment.cancelKeep')}
                    </Button>
                </View>
            </View>
        </Modal>
    )
}

const styles = createStyleSheet({
    container: { paddingHorizontal: 16, paddingVertical: 32, gap: 32 },
    title: { textAlign: 'center' },
    actions: { gap: 16 },
    button: { width: '100%', minHeight: 44, justifyContent: 'center', borderRadius: 8 },
})

export default CancelPaymentModal
